"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var adup = require("../../lsb/ui-components/adup-v2/src/adup");
var adup_lastupdate_1 = require("../../lsb/ui-components/adup-v2/src/adup-lastupdate");
// import { renderWarrantyWidget } from "../../cs_warrantywidget/src/warrantywidget";
// import "../../cs_warrantywidget/sass/warrantylookupwidget.scss";
var content_driver_1 = require("./content-driver");
var content_supersede_list_1 = require("./content-supersede-list");
var content_codependency_1 = require("./content-codependency");
var content_backtop_1 = require("./content-backtop");
var common_1 = require("../../psp_driverlist/src/common");
var l = require("lenovo");
var t = l.Translator.translate;
exports.Render = function (data) {
    if (data.error == 2 || data.error == 3 || data.error == 4) {
        window.location.href = '/pagenotfound';
        return;
    }
    if (data.error == 1) {
        if (!l.AccountAuthentication.isLogin()) {
            window.location.href = l.AccountAuthentication.getPassportLenovoUrl("NewLenovoLoginUrl");
        }
        else {
            ReactDOM.render(React.createElement("div", { className: "no-permission" },
                React.createElement("div", { className: "left" },
                    React.createElement("span", { className: "icon-warning iconsize" })),
                React.createElement("div", { className: "right" },
                    React.createElement("p", null, t("no permission to driver")))), document.getElementById("dowDriverFileList"));
        }
        return;
    }
    try {
        if (data && data.NoAuthor && data.NoAuthor == "true") {
            try {
                if (window["config"] != undefined && window["config"] != null) {
                    if (window["config"].user.LoggedIn == true) {
                        window.location.href = l.UrlUtility.getFullPath("/insufficientpermissions");
                        return;
                    }
                }
            }
            catch (ess) {
            }
            window.location.href = l.UrlUtility.getFullPath("/preauth?ReturnUrl=" + encodeURI(window.location.href));
            return;
        }
    }
    catch (e) { }
    if (!data) {
        $(".dow-ds-content,.dow-ds-search").html("");
        window.location.href = l.UrlUtility.getFullPath("/page-not-found?item=" + encodeURI(window.location.href + "&user=extranet\Anonymous&site=ESupport"));
        return;
    }
    if (data.Name) {
        document.title = data.Name;
    }
    // fix media reference issue
    if (data.hasOwnProperty("Body")) {
        var body = data["Body"];
        var r = new RegExp(";~/media/", "gi");
        body = body.replace(r, ";/~/media/");
        data["Body"] = body;
    }
    if (!window["ds_content"]) {
        window["ds_content"] = data;
    }
    try {
        if (window["lmd"] != null && window["lmd"] != undefined) {
            if (data.Body && data.Body.indexOf(".auto-trans") > -1) {
                window["lmd"]["machinetranslated"] = 1;
            }
            else {
                window["lmd"]["machinetranslated"] = 0;
            }
            var mt = $("#divauto-tranmt").data("mt");
            if (mt) {
                window["lmd"]["machinetranslated"] = mt;
            }
            window["lmd"]["docID"] = data.DocId;
            window["lmd"]["docType"] = data.Type;
        }
    }
    catch (e) {
    }
    $("#contentBody").html($($.parseHTML(data.Body)).text());
    if (data.Type == "Driver") {
        var RenderList = function () {
            if (data.Files && data.Files.length > 0) {
                ReactDOM.render(React.createElement(content_driver_1.DriverList, { data: data }), document.getElementById("dowDriverFileList"));
            }
            else {
                ReactDOM.render(React.createElement("div", { className: "dow-ds-diver" },
                    React.createElement("ul", { className: "dow-list-item dow-ds-title-min-h" },
                        React.createElement("li", { className: "col-lg-12 col-md-12 col-xs-12 dow-item-child dow-ds-flex dow-ds-driver-title" },
                            React.createElement("span", { className: 'dow-title  dow-pull-left' }, data.Title))),
                    data.Description ? React.createElement("ul", { className: "dow-ds-props", style: { borderTop: "1px solid #ddd" } },
                        React.createElement("li", null,
                            React.createElement("span", { className: "dow-ds-props-title" }, l.Translator.translate("Description|Description")),
                            React.createElement("p", null, data.Description))) : null), document.getElementById("dow_driver_title_no_file"));
            }
        };
        RenderList();
        ReactDOM.render(React.createElement("p", null,
            React.createElement("a", { className: "dow-link-to", href: "http://www.lenovo.com/privacy/software/us/en/" }, l.Translator.translate("please click here to access the lenovo software privacy statement|Please click here to access the Lenovo Software Privacy Statement"))), document.getElementById("linkToStatement"));
        if (l.Common.isWin7OrAbove(true)) {
            //load adup
            ReactDOM.render(React.createElement(adup_lastupdate_1.AdupTabButtonTitleLastUpdate, null), document.getElementById("ds_adup_last_update"));
            if (l.Common.getCurrentRealm() === l.RealmType.Pcg) {
                $(".dow-ds-tiles-container").css("display", "flex");
                adup.adupload(document.getElementById('aduptab'), 1, 0);
            }
        }
        if (l.Common.getCurrentRealm() === l.RealmType.Pcg && common_1.Utils.isMobile()) {
            $(".dow-ds-mobile-tile").show();
        }
        // if (data.Supersedes != null && data.Supersedes.length != null && data.Supersedes.length > 0) {
        //     $("#contentBody").append('<div id="supersedeContainer"></div>');
        //     ReactDOM.render(<SupersedeList supersedes={data.Supersedes} />, document.getElementById("supersedeContainer"));
        // }
        if (data.Supersedes != null && data.Supersedes.length != null && data.Supersedes.length > 0) {
            $("#contentBody").append('<div id="supersedeMatrixContainer"></div>');
            ReactDOM.render(React.createElement(content_supersede_list_1.SupersedeMatrixList, null), document.getElementById("supersedeMatrixContainer"));
        }
        if (data.CoDependency && data.CoDependency.length && data.CoDependency.length > 0) {
            $("#contentBody").append('<div id="CoDependencyContainer"></div>');
            ReactDOM.render(React.createElement(content_codependency_1.CoDependency, { CoDependency: data.CoDependency }), document.getElementById("CoDependencyContainer"));
        }
    }
    var lock_iconstr = null;
    try {
        if (isCCorSP(data.Audiences)) {
            lock_iconstr = React.createElement("img", { className: "lock_icon", style: { height: "18px", margin: "0 0 2px 5px" }, src: "/msa/driver/images/lock_icon.png", alt: "" });
        }
    }
    catch (e) { }
    if (data.DocId.startsWith('HT') || data.DocId.startsWith('PD') || data.DocId.startsWith('DS')) {
        ReactDOM.render(React.createElement(content_backtop_1.DS_BackTop, null), document.getElementById("BackToTop"));
    }
    setLock();
    if (typeof ds_warrantywidget !== 'undefined') {
        if (ds_warrantywidget.Flag && ds_warrantywidget.Flag == "1") {
            var widgetContent = $('div[' + ds_warrantywidget.PlaceHolder + ']').get(0);
            if (widgetContent) {
                renderWarrantyWidget(widgetContent);
            }
        }
    }
    else {
        console.log('ds_warrantywidget not found.');
    }
    var releaseDate = data.Date ? common_1.Utils.driverListDateTime(data.Date.Unix) : "";
    ReactDOM.render(React.createElement("div", null,
        data.Alias ? React.createElement("div", null,
            React.createElement("span", { className: "dow-doc-title" },
                l.Translator.translate("alias id|Alias ID"),
                ": "),
            " ",
            React.createElement("span", { className: "dow-doc-value" },
                data.Alias,
                React.createElement("br", null))) : "",
        data.FixID ? React.createElement("div", null,
            React.createElement("span", { className: "dow-doc-title" },
                l.Translator.translate("fix iD|Fix ID"),
                ": "),
            React.createElement("span", { className: "dow-doc-value" },
                data.FixID,
                React.createElement("br", null)),
            " ") : "",
        releaseDate ? React.createElement("div", null,
            React.createElement("span", { className: "dow-doc-title" },
                l.Translator.translate("release date|Release Date"),
                ":"),
            React.createElement("span", { className: "dow-doc-value" },
                " ",
                releaseDate)) : null,
        data.DocId ? React.createElement("div", null,
            React.createElement("span", { className: "dow-doc-title" },
                l.Translator.translate("document id|Document ID"),
                ":"),
            React.createElement("span", { className: "dow-doc-value" },
                " ",
                data.DocId,
                React.createElement("br", null))) : null), document.getElementById("documentInfo"));
};
window["unLock"] = function (ele) {
    var dataset = ele.dataset;
    var locktype = dataset.locktype;
    var url = dataset.url;
    if (locktype == 'restrict-country') {
        common_1.Utils.showInwarriantySNCaps(function () { common_1.Utils.loading(true); }, function () { common_1.Utils.loading(false); });
    }
    if (locktype == 'require-login') {
        common_1.Utils.showLoginTips(function () {
            window.location.href = l.AccountAuthentication.getPassportLenovoUrl("NewLenovoLoginUrl");
        });
    }
    if (locktype == 'in-warranty') {
        common_1.Utils.showInwarriantySNCaps(function () { common_1.Utils.loading(true); }, function () { common_1.Utils.loading(false); });
    }
    if (locktype == 'require-pncheck') {
        common_1.Utils.showPNCheckCaps(function () { common_1.Utils.loading(true); }, function () { common_1.Utils.loading(false); });
    }
};
function setLock() {
    if ($('#dowDriverFileList .dow-box .dow-lock')[0]) {
        var items = $('#contentBody table tr td a');
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            $(item).removeAttr("href").css("color", "#333").css("cursor", "default");
            $(item).after('<span style="float: right; margin-right: 12px" class="icon-lock dow-lock" title="click and unlock" onclick="unLock($(\'#dowDriverFileList .dow-box .dow-lock\')[0])"></span>');
        }
    }
}
function isCCorSP(audience) {
    if (!audience || audience === null) {
        return false;
    }
    var show = false;
    for (var i = 0; i < audience.length; i++) {
        if (audience[i].Id == "CALL_CENTER" || audience[i].Id == "SERVICE_PROVIDER") {
            show = true;
        }
        if (audience[i].Id == "ANONYMOUS" || audience[i].Id == "CUSTOMER" || audience[i].Id == "B99F6570-6875-4270-9089-BB83F69529EB") {
            return false;
        }
    }
    return show;
}
function ToLocaleDateStr(date) {
    try {
        if (!date) {
            return "";
        }
        var dt = new Date(date.Unix);
        var tempdatastr = (dt.getMonth() + 1) + '/' + dt.getDate() + '/' + dt.getFullYear();
        return tempdatastr;
    }
    catch (e) { }
    return date;
}
